import "core-js/modules/web.dom-collections.iterator.js";
import { SharingRemixPage } from "~/utils/sharing-remix-page";
import { POIBody } from "@poi/body";
import { POIHead } from "@poi/head";
import { cssLinks } from "@ttark/css-links";
import { buildSharingLoader } from "~/utils/sharing-loader";
var links = () => [...cssLinks("routes/poi.$poi_id")];
var loader = buildSharingLoader("poi");
var POIPage = class extends SharingRemixPage {
  constructor() {
    super(...arguments);
    this.Head = POIHead;
    this.Body = POIBody;
  }
};
var clientLoader = async _ref => {
  let {
    serverLoader
  } = _ref;
  const serverData = await serverLoader();
  return serverData;
};
export { clientLoader, POIPage as default, links };